




























































import { IInventoryAdvancePayment } from '@/models';
import { mapActions, mapGetters } from 'vuex';
import InventoryAdvancePaymentDetail from '@/components/inventory-advance-payment/InventoryAdvancePaymentDetail.vue';
import InventoryAdvancePaymentDetailActivityCard from '@/components/inventory-advance-payment/InventoryAdvancePaymentDetailActivityCard.vue';
import InventoryAdvancePaymentStateCard from '@/components/inventory-advance-payment/InventoryAdvancePaymentStateCard.vue';
import InventoryAdvancePaymentDetailDrawer from '@/components/inventory-advance-payment/InventoryAdvancePaymentDetailDrawer.vue';
import { ErrorManager } from '@/models/error';
import Snackbar from '@/mixins/snackbar';

export default Snackbar.extend({
  components: {
    InventoryAdvancePaymentDetail,
    InventoryAdvancePaymentDetailActivityCard,
    InventoryAdvancePaymentDetailDrawer,
    InventoryAdvancePaymentStateCard
  },

  data: () => ({
    loading: false,
    errorMessage: ''
  }),

  mounted() {
    // only fetch inventoryAdvancePayment if not available in store ("try-get-or-fetch")
    if (!this.inventoryAdvancePayment) {
      this.loading = true;
      this.fetchInventoryAdvancePayment(Number(this.inventoryAdvancePaymentId))
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.loading = false));
    }
  },

  computed: {
    ...mapGetters({
      getInventoryAdvancePaymentById:
        'inventoryAdvancePayment/getInventoryAdvancePaymentById'
    }),

    inventoryAdvancePaymentId(): string {
      return this.$route.params.id;
    },

    inventoryAdvancePayment(): IInventoryAdvancePayment | undefined {
      return this.getInventoryAdvancePaymentById(
        Number(this.inventoryAdvancePaymentId)
      );
    },

    errorOccurred(): boolean {
      return this.errorMessage.length > 0;
    }
  },

  methods: {
    ...mapActions({
      fetchInventoryAdvancePayment:
        'inventoryAdvancePayment/fetchInventoryAdvancePayment'
    }),

    routeBackToList(action: string) {
      this.$router
        .replace({ name: 'inventory-advance-payment-list' })
        .then(() => {
          this.createSnack({
            color: 'success darken-1',
            type: 'success',
            right: true,
            useBtn: false,
            msg: `Inventory Advance Payments ${action}`,
            btnText: 'Ok',
            timeout: 6000
          });
        });
    }
  }
});
